module.exports = __webpack_public_path__ + "static/img/batterymonitor.373e616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/batterymonitor.png
// module id = wDfo
// module chunks = 1